import React from 'react';
import LegalPolicyPage from '../components/content/LegalPolicyPage.jsx';
import { privacyPolicyFallback } from './legalPageDefaults.js';

export default function PrivacyPolicyPage() {
  return <LegalPolicyPage slug="privacy-policy" fallback={privacyPolicyFallback} />;
}
